export default "__VITE_ASSET__lepxaW$y__"